import { Component, Input } from '@angular/core';
import { InvoiceOcrUploaderComponent } from '../invoice-ocr-uploader/invoice-ocr-uploader.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-auto-fill-section',
  templateUrl: './auto-fill-section.component.html',
  styleUrls: ['./auto-fill-section.component.scss'],
  imports: [InvoiceOcrUploaderComponent, TranslateModule],
})
export class AutoFillSectionComponent {
  /**
   * Where to render the "VAGY" divider relative to the OCR uploader.
   *  - `top` (default): divider above the OCR – used when this section is
   *     placed below other content (e.g. claims list).
   *  - `bottom`: divider below the OCR (and the alternative methods) – used
   *     when this section is placed above the manual entry fields (e.g. on
   *     the debtor form, separating OCR from the manually fillable fields).
   *  - `none`: no divider rendered.
   */
  @Input() orPosition: 'top' | 'bottom' | 'none' = 'top';
}
